import { FaFileAlt, FaClock, FaDownload } from "react-icons/fa";

function CiudadanoStats() {
    return (
        <div className="mb-[25px] grid grid-cols-1 gap-5 sm:grid-cols-3">
            <div className="rounded-[var(--radius-md)] bg-white p-[25px] text-center shadow-[0_5px_15px_rgba(0,0,0,0.08)]">
                <FaFileAlt className="mx-auto text-[35px] text-primary" />
                <h2 className="mt-[15px] mb-[5px] text-[32px] font-bold text-primary">12</h2>
                <span className="text-sm text-text-muted">Certificados Emitidos</span>
            </div>
            <div className="rounded-[var(--radius-md)] bg-white p-[25px] text-center shadow-[0_5px_15px_rgba(0,0,0,0.08)]">
                <FaClock className="mx-auto text-[35px] text-primary" />
                <h2 className="mt-[15px] mb-[5px] text-[32px] font-bold text-primary">3</h2>
                <span className="text-sm text-text-muted">En Validación</span>
            </div>
            <div className="rounded-[var(--radius-md)] bg-white p-[25px] text-center shadow-[0_5px_15px_rgba(0,0,0,0.08)]">
                <FaDownload className="mx-auto text-[35px] text-primary" />
                <h2 className="mt-[15px] mb-[5px] text-[32px] font-bold text-primary">8</h2>
                <span className="text-sm text-text-muted">Descargados</span>
            </div>
        </div>
    );
}

export default CiudadanoStats;
